import React, { useEffect, useState } from 'react';
import DataTable, { defaultThemes } from 'react-data-table-component';
import { getActivityLog, getAdminLists } from '../../Services/allApi';
import { Icon } from '@iconify/react/dist/iconify.js';

const ActivityLog = () => {
  const [width, setWidth] = useState(0);
  const [refreshTimer, setRefreshTimer] = useState(60);
  const [logList, setLogList] = useState([]);

  const customStyles = {
    rows: {
      style: {
        '&:nth-child(odd)': {
          backgroundColor: '#F5F8FA',
          minHeight: '50px',
        },
        '&:nth-child(even)': {
          backgroundColor: 'white',
          minHeight: '50px',
        },
      },
    },
    headRow: {
      style: {
        borderTopStyle: 'solid',
        // borderTopWidth: '1px',
        borderTopColor: defaultThemes.default.divider.default,
        backgroundColor: '#18A0FB',
        color: 'white',
        height: '50px',
      },
    },
    headCells: {
      style: {
        '&:not(:last-of-type)': {
          borderRightStyle: 'solid',
          // borderRightWidth: '1px',
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        '&:not(:last-of-type)': {
          borderRightStyle: 'solid',
          // borderRightWidth: '1px',
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  const columns = [
    { name: 'Sl No', selector: row => row.slno, sortable: true },
    { name: 'Action performed', selector: row => row.action, sortable: true, minWidth: '230px', maxWidth: '250px', },
    { name: 'Method', selector: row => row.method, sortable: true },
    { name: 'Status', selector: row => row.response, sortable: true },
    { name: 'Date', selector: row => row.date, sortable: true },
    { name: 'Time', selector: row => row.time, sortable: true },
    { name: 'User', selector: row => row.userId, sortable: true },
    { name: 'Parameter', selector: row => row.parameter, sortable: true, minWidth: '390px', maxWidth: '410px', },
    
  ];

  const logListApi = async () => {
    const token = sessionStorage.getItem('access_token');
    const reqHeader = {
      "Content-Type": "application/json",
      "Authorization": `${token}`,
    };
    const result = await getActivityLog(reqHeader);
    console.log(result);
    setLogList(result?.data);
  };

  useEffect(() => {
    logListApi();
  }, []);

  const data = logList?.map((item, index) => ({
    slno: index + 1,
    action: item?.action_performed,
    method: item?.method,
    response:
      <div className='flex flex-row justify-center items-center'>
        <span
          className={`${item?.response_status >= 200 && item?.response_status < 300
              ? 'bg-green-500 text-white'
              : 'bg-red-500 text-white'
            } px-4 py-1 font-bold rounded-full`}
        >
          {item?.response_status}
        </span>      </div>,
    date: item?.timestamp?.slice(0, 10),
    time: item?.timestamp?.split("T")[1]?.slice(0, 5),
    userId: item?.user_id,
    parameter: item?.parameter
    // is_active: (
    //   <div className='flex flex-row gap-1 items-center'>
    //     <Icon icon={`${item?.is_active ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item?.is_active ? 'green' : 'red'}` }} className='text-lg' />
    //     <p className={item?.is_active ? 'text-green-500' : 'text-red-500'}>{item?.is_active ? 'Active' : 'Inactive'}</p>
    //   </div>
    // ),
  }));

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshTimer((prevTimer) => {
        if (prevTimer > 1) {
          setWidth((prevWidth) => (60 - prevTimer + 1) * (100 / 60));
           return prevTimer - 1;
        } else {
          setWidth(0);
          logListApi();
          return 60;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    setRefreshTimer(60);
    setWidth(0);
    logListApi();
  };

  const handleDownload=()=>{
    console.log(logList);
      // Convert JSON data to string
      const jsonString = JSON.stringify(logList, null, 2);
      // Create a Blob from the JSON string
      const blob = new Blob([jsonString], { type: 'application/json' });
      // Create a URL for the Blob
      const url = URL.createObjectURL(blob);
      // Create a temporary anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = 'logList.json'; // Specify the file name for the download
      // Append the anchor to the body (required for Firefox)
      document.body.appendChild(a);
      // Trigger the download by simulating a click event
      a.click();
      // Remove the anchor from the body
      document.body.removeChild(a);
      // Revoke the Blob URL to free up memory
      URL.revokeObjectURL(url);
    };
    
  

  return (
    <div className='flex flex-col w-full'>
      <div className='flex flex-row justify-between items-center px-10'>
        <div className='flex flex-row items-center gap-5 pb-5 pt-5 w-full'>
          <h1 className=' font-extrabold text-2xl'>Activity Log</h1>
          <p className='text-gray-700 '>Auto refresh in <span className='bg-yellow-200 px-2 rounded-full'>{refreshTimer}</span> seconds</p>

        </div>
        <div className='flex flex-row gap-2'>

          <button className='pl-5 px-4 py-1 bg-gray-100 rounded-full text-blue-500 border hover:text-white hover:bg-blue-700 flex flex-row gap-1 items-center' onClick={handleDownload}><span>Download</span><Icon icon="line-md:download-outline" /></button>
          <button className='pl-5 px-4 py-1 bg-gray-100 rounded-full text-blue-500 border hover:text-white hover:bg-blue-700 flex flex-row gap-1 items-center' onClick={handleRefresh}><span>Refresh</span><Icon icon="bx:refresh" /></button>

        </div>
      </div>
      <div className="w-full h-1 bg-gray-200 mt-2 rounded-full ">
        <div
          className="h-full bg-blue-900 rounded-full"
          style={{ width: `${width}%`, transition: 'width 1s linear' }}
        ></div>
      </div>
      <div className='w-full border-2 rounded-b '>
        <DataTable
          columns={columns}
          data={data}
          customStyles={customStyles}
          pagination
          dense
          highlightOnHover
          selectableRowsHighlight
          paginationPerPage={50} // Initial page size
          paginationRowsPerPageOptions={[50, 100, 200, 500]} // Options for users to change page size
        />
      </div>
    </div>
  );
};

export default ActivityLog;
